<vm-article-shell
  *ngIf="articleContent"
  [content]="articleContent"
></vm-article-shell>

<vm-advice-shell
  *ngIf="adviceContent?.items?.length>0"
  [items]="adviceContent?.items"
  [backRoute]="adviceContent?.backRoute"
  [doneRoute]="adviceContent?.doneRoute"
></vm-advice-shell>